jQuery(function ($) {
    "use strict";

    $({ Counter: 0 }).animate({
      Counter: $('.volume-item-number-number[data-num]').val()
    }, {
      duration: 1000,
      easing: 'swing',
      step: function() {
        $('.volume-item-number-number').text(Math.ceil(this.Counter));
      }
    });


    $('#quote-fileattach').on('change', function(){
      if($('#quote-fileattach').val()){
        $('#file-attachment').addClass('selected');
      }else{
        $('#file-attachment').removeClass('selected');
      }
    });
    
    $('.carousel-clients').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 5,
      slidesToScroll: 1,
      nextArrow: '<button type="button" class="slick-next"><i class="bi bi-chevron-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="bi bi-chevron-left"></i></button>',
      responsive: [
      {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 1
          }
          },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    /* =Mask jQuery
    -------------------------------------------------------------- */
    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-dateTime').mask('00/00/0000 00:00:00');
    $('.mask-cep').mask('00.000-000');
    $('.mask-cpf').mask('000.000.000-00');
    $('.mask-cnpj').mask('00.000.000/0000-00');
    $('.mask-money').mask('000.000.000.000.000,00', {reverse: true});
    var CelMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        celOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(CelMaskBehavior.apply({}, arguments), options);
            }
        };

    $('.mask-tel').mask(CelMaskBehavior, celOptions);

});